import * as React from 'react';
import {
  Box,
  Button,
  Flex,
  Image,
  LightMode,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text
} from '@chakra-ui/react';

export const warrantyTitle = 'Ihre gesetzlichen Gewährleistungsrechte';
export const warrantyEuUrl = 'https://europa.eu/youreurope/garantien';
const labelPath = '/gewaehrleistung/EU-Gewaehrleistungslabel_Farbe';
export const warrantyImage = `${labelPath}.png`;

export const WarrantyLabel: React.FC<{ fitToViewport?: boolean }> = ({ fitToViewport = false }) => {
  const [enlarged, setEnlarged] = React.useState(false);
  const regionId = React.useId();
  return (
    <>
      <Flex gap={3} align="center" justify="space-between" wrap="wrap" mb={4}>
        <Link
          href={warrantyEuUrl}
          textDecoration="underline"
          textUnderlineOffset="3px"
          fontSize="sm"
          overflowWrap="anywhere"
          py={2}
        >
          europa.eu/youreurope/garantien
        </Link>
        <Button
          onClick={() => setEnlarged(value => !value)}
          aria-pressed={enlarged}
          aria-controls={regionId}
          size="sm"
          variant="outline"
        >
          {enlarged ? 'Gesamtes Label' : 'Label vergrößern'}
        </Button>
      </Flex>
      <Box
        id={regionId}
        data-warranty-label
        role="region"
        aria-label="Vollständiges offizielles EU-Gewährleistungslabel"
        overflowX="auto"
        tabIndex={enlarged ? 0 : undefined}
      >
        <Image
          src={warrantyImage}
          alt="Vollständiges offizielles deutsches EU-Label zur gesetzlichen Gewährleistung einschließlich QR-Code"
          width={1697}
          height={2400}
          w={enlarged ? '1200px' : fitToViewport ? 'auto' : '100%'}
          maxW={enlarged ? 'none' : '100%'}
          maxH={!enlarged && fitToViewport ? 'calc(100dvh - 260px)' : undefined}
          h="auto"
          mx={enlarged ? 0 : 'auto'}
          loading="eager"
        />
      </Box>
      <Link
        href={`${labelPath}.pdf`}
        textDecoration="underline"
        textUnderlineOffset="3px"
        display="inline-block"
        py={3}
        mt={2}
        fontSize="sm"
      >
        Unverändertes Original-PDF öffnen
      </Link>
      <Text fontSize="sm" color="gray.600" mb={3}>
        Zum Lesen können Sie das Label vergrößern und seitlich scrollen.
      </Text>
    </>
  );
};

export const WarrantyModal: React.FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => (
  <LightMode>
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" scrollBehavior="inside" isCentered returnFocusOnClose>
      <ModalOverlay bg="blackAlpha.800" />
      <ModalContent bg="white" color="black" lang="de" mx={[3, 6]} my={4} maxH="calc(100dvh - 32px)" borderRadius="lg">
        <ModalHeader fontSize={['lg', '2xl']} pr={12} pb={2}>
          {warrantyTitle}
        </ModalHeader>
        <ModalCloseButton aria-label="Label schließen" />
        <ModalBody px={[4, 6]} pb={3}>
          <WarrantyLabel fitToViewport />
        </ModalBody>
      </ModalContent>
    </Modal>
  </LightMode>
);
